import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import apiToken, { handleApiError } from '@/shared/services/axiosInstance';
import { useAuthStore } from '@/shared/stores/useAuthStore';

import Nav from './Nav';
import Search from './Search';

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [artistCategoryData, setArtistCategoryData] = useState([]);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const getCategory = async () => {
    try {
      const response = await apiToken.get('/api/v1/category');
      setCategoryData(response.data.data);
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to fetch category:', errorMessage);
      alert(
        'Failed to load categories. Please refresh the page and try again.',
      );
    }
  };

  const getArtistCategory = async () => {
    try {
      const response = await apiToken.get('/api/v1/artist/category');
      const sortedData = response.data.data.artistCategoryList.sort(
        (a: { id: number }, b: { id: number }) => a.id - b.id,
      );
      setArtistCategoryData(sortedData);
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to fetch artist category:', errorMessage);
      alert(
        'Failed to load artist categories. Please refresh the page and try again.',
      );
    }
  };

  useEffect(() => {
    getCategory();
    getArtistCategory();
  }, []);
  return (
    <nav className="bg-white">
      {searchOpen && <Search setSearchOpen={setSearchOpen} />}
      {!searchOpen && (
        <div className="mx-auto flex h-[90px] max-w-5xl items-center justify-between px-4">
          <div className="flex-1" />
          <Link to="/" className="flex flex-1 justify-center">
            <img src="/images/logo_b2b.svg" alt="logo" className="h-12" />
          </Link>
          <div className="flex flex-1 justify-end gap-4">
            <button
              type="button"
              onClick={() => {
                setSearchOpen(true);
              }}
            >
              <img src="/images/search.svg" alt="search" className="h-6" />
            </button>
            <Link to={isAuthenticated ? '/cart' : '/login'} type="button">
              <img
                src="/images/shoppingcart_b.svg"
                alt="cart"
                className="h-6"
              />
            </Link>
            <Link to={isAuthenticated ? '/mypage' : '/login'}>
              <img src="/images/user.svg" alt="user" className="h-6" />
            </Link>
          </div>
        </div>
      )}
      <div
        onMouseLeave={() => setNavOpen(false)}
        className="border-b border-t border-[#eee] bg-white"
      >
        <ul
          onMouseEnter={() => {
            setNavOpen(true);
          }}
          className="mx-auto flex h-12 max-w-5xl justify-center"
        >
          {[
            'NEW',
            'K-ARTIST',
            'K-ALBUM',
            'K-MERCH',
            'K-MAGAZINE',
            'K-EVENT',
            'CONTACT US',
          ].map((item) => (
            <li
              key={item}
              className="flex h-[50px] w-[170px] cursor-pointer items-center justify-center text-xs font-semibold tracking-[2px] text-[#444]"
            >
              {item}
            </li>
          ))}
        </ul>
        {navOpen && (
          <Nav
            categoryData={categoryData}
            artistCategoryData={artistCategoryData}
          />
        )}
      </div>
    </nav>
  );
};

export default Header;
